// searchReducer.js

import { 
  SET_AMOUNT_MATCHES_CURRENT_ALL,
  SET_TOTAL_MATCHES_ALL, 
  SET_AMOUNT_MATCHES_CURRENT_LIVE, 
  SET_TOTAL_MATCHES_LIVE, 
  SET_AMOUNT_MATCHES_CURRENT_RESULT, 
  SET_TOTAL_MATCHES_RESULT, 
  SET_COLLAGE_PAGINATION, 
} from './actionTypes';
import { searchText } from './initialState';
const INITIAL_STATE = {
  amountMatchesCurrentAll: 0,
  totalMatchesAll: 0,
  amountMatchesCurrentLive: 0,
  totalMatchesLive: 0,
  amountMatchesCurrentResult: 0,
  totalMatchesResult: 0,
  paginationStatus: false,
}

const PagingReducer = (state: any = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SET_AMOUNT_MATCHES_CURRENT_ALL:
      return { ...state, amountMatchesCurrentAll: action.payload };
    case SET_TOTAL_MATCHES_ALL:
      return { ...state, totalMatchesAll: action.payload };
    case SET_AMOUNT_MATCHES_CURRENT_LIVE:
      return { ...state, amountMatchesCurrentLive: action.payload };
    case SET_TOTAL_MATCHES_LIVE:
      return { ...state, totalMatchesLive: action.payload };
    case SET_AMOUNT_MATCHES_CURRENT_RESULT:
      return { ...state, amountMatchesCurrentResult: action.payload };
    case SET_TOTAL_MATCHES_RESULT:
      return { ...state, totalMatchesResult: action.payload };
    case SET_COLLAGE_PAGINATION:
      return { ...state, paginationStatus: action.payload };
    default:
      return state;
  }
};

export default PagingReducer;
